import { SPEED_SETTINGS } from "app/data/game-settings";
import { WordCompletionStatus } from "app/speed/speedState";
import { useSpeedState } from "app/speed/useSpeed";
import remap from "app/utils/remap";

// Returns the player's score info for the current speed round
export default function useCurrentScore(numWords: number) {
  const roundState = useSpeedState();

  // Before time has been calculated, return the max score
  if (roundState.timeRemaining === -1) {
    return {
      timeBonus: SPEED_SETTINGS.maxTimeScore,
      streakBonus: 0,
      numCorrectSpellings: 0,
      numIncorrectSpellings: 0,
    };
  }

  const numCorrect = roundState.completedWordStatuses.filter(
    (wordStatus) => wordStatus === WordCompletionStatus.CORRECT
  ).length;

  const numIncorrect = roundState.completedWordStatuses.filter(
    (WordStatus) => WordStatus === WordCompletionStatus.INCORRECT
  ).length;

  const gracePeriod = SPEED_SETTINGS.gracePeriodPerWord * numWords;
  const timeScore = remap(
    roundState.timeRemaining,
    0,
    roundState.maxDuration - gracePeriod,
    0,
    SPEED_SETTINGS.maxTimeScore,
    true
  );

  const wrongAnswerPenalty =
    roundState.numWrongAnswers * SPEED_SETTINGS.incorrectPenalty;
  const skipPenalty = roundState.numWrongAnswers * SPEED_SETTINGS.skipPenalty;

  const currentScore = Math.max(
    timeScore - wrongAnswerPenalty - skipPenalty,
    0
  );

  const streakBonus =
    roundState.maxStreak in SPEED_SETTINGS.streakBonuses
      ? SPEED_SETTINGS.streakBonuses[roundState.maxStreak]
      : 0;

  const flooredScore = Math.floor(currentScore);

  return {
    timeBonus: flooredScore,
    streakBonus,
    numCorrectSpellings: numCorrect,
    numIncorrectSpellings: numIncorrect,
  };
}
